import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

export const subscriptionsAdapter =
  createEntityAdapter<API.SubscriptionsEntity>({
    selectId: (cardSubscriptions) => cardSubscriptions.card_id,
  });

const slice = createSlice({
  name: "subscriptions",
  initialState: subscriptionsAdapter.getInitialState(),
  reducers: {
    setMany: subscriptionsAdapter.setMany,
    setOne: subscriptionsAdapter.setOne,
    flush: subscriptionsAdapter.removeOne,
  },
});

export const { actions } = slice;

export default {
  subscriptions: slice.reducer,
};
